import { loadingFadeOut } from 'virtual:app-loading'
import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router'
import { handleHotUpdate, routes } from 'vue-router/auto-routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),

  routes: setupLayouts(routes),
})

router.isReady().then(() => {
  loadingFadeOut()
})

router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  const { userInfo } = storeToRefs(userStore)
  if (to.path !== '/login' && !userInfo.value) {
    next('/login')
  }
  else {
    next()
  }
})

if (import.meta.hot) {
  handleHotUpdate(router)
}

export default router
